import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Snackbar,
  Alert,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Typography,
  Box,
  DialogContentText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ThemeContext } from "../../../../../../../../context/ThemeContextProvider";
import { updateOrder } from "../../../../../../../../services/pos/Tables";

const EditOrderFormTableNumber = ({ open, onClose, initialData, tables }) => {
  const { mode } = useContext(ThemeContext);
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm")); // phones
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:1200px)"); // tablets / iPad
  const controlSize = isTablet ? "medium" : isXs ? "small" : "small";
  const dialogWidth = isXs ? "100vw" : isTablet ? "90vw" : 560;
  const [form, setForm] = useState({});
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedTable, setSelectedTable] = useState("");

  useEffect(() => {
    if (initialData) {
      setForm({
        ...initialData,
        customer_id: initialData.customer?.id ?? null, // أفضل من ""
      });
      setSelectedTable(initialData.table_id || "");
    }
  }, [initialData]);

  const handleTableChange = (e) => {
    setSelectedTable(e.target.value);
  };

  const handleConfirm = async () => {
    try {
      if (!form.order_id) throw new Error("❌ رقم الأوردر غير موجود");

      await updateOrder(form.order_id, {
        table_id: selectedTable,
        customer_id: form.customer_id,
      });

      setSuccess(true);
      setConfirmOpen(false);

      // ✨ رجع البيانات الجديدة للـ parent عشان يحدث الـ state محليًا
      onClose({
        table_id: selectedTable,
        customer_id: form.customer_id,
      });
    } catch (err) {
      setError(err.message || "❌ فشل في نقل الطاولة");
      setConfirmOpen(false);
    }
  };

  const currentTableObj = tables.find((t) => t.id === form.table_id);
  const newTableObj = tables.find((t) => t.id === selectedTable);

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        fullScreen={isXs}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: dialogWidth,
            maxWidth: "98vw",
            bgcolor: mode === "dark" ? "#232334" : "#fff",
            color: mode === "dark" ? "#fff" : "#232334",
            borderRadius: { xs: 0, sm: 3 },
          },
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setConfirmOpen(true);
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 700,
              fontSize: { xs: 18, sm: 20, md: 22 },
              textAlign: "center",
              color: "#EA7C69",
              bgcolor: mode === "dark" ? "#181824" : "#fff",
              borderRadius: { xs: 0, sm: "16px 16px 0 0" },
            }}
          >
            نقل الطاولة
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              pb: { xs: 1.5, sm: 2 },
            }}
          >
            <Box mb={2}>
              <Typography sx={{ fontWeight: 600, mb: 1 }}>
                الطاولة الحالية:{" "}
                <span style={{ color: "#EA7C69" }}>
                  {currentTableObj?.name || form.table_id || "-"}
                </span>
              </Typography>
            </Box>
            <FormControl
              fullWidth
              sx={{
                bgcolor: mode === "dark" ? "#181824" : "#fff",
                borderRadius: 2,
              }}
            >
              <InputLabel sx={{ color: mode === "dark" ? "#aaa" : undefined }}>
                اختر الطاولة الجديدة
              </InputLabel>
              <Select
                label="اختر الطاولة الجديدة"
                name="table_id"
                value={selectedTable}
                onChange={handleTableChange}
                size={controlSize}
                sx={{
                  color: mode === "dark" ? "#fff" : "#232334",
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: mode === "dark" ? "#444" : "#ccc",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      bgcolor: mode === "dark" ? "#232334" : "#fff",
                      color: mode === "dark" ? "#fff" : "#232334",
                    },
                  },
                }}
              >
                {tables && tables.length > 0 ? (
                  tables.map((table) => (
                    <MenuItem key={table.id} value={table.id}>
                      {table.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>لا توجد طاولات متاحة</MenuItem>
                )}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              borderRadius: { xs: 0, sm: "0 0 16px 16px" },
              px: { xs: 2, sm: 3 },
              py: { xs: 1, sm: 1.25 },
              justifyContent: "flex-end",
            }}
          >
            <Button
              onClick={() => onClose(false)}
              variant="outlined"
              color="secondary"
              size={controlSize}
              sx={{
                minWidth: 100,
                borderColor: mode === "dark" ? "#888" : undefined,
                color: mode === "dark" ? "#fff" : undefined,
                px: { xs: 2, sm: 3 },
              }}
            >
              إلغاء
            </Button>
            <Button
              variant="contained"
              type="submit"
              size={controlSize}
              disabled={!selectedTable || selectedTable === form.table_id}
              sx={{
                bgcolor: "#EA7C69",
                color: "#fff",
                minWidth: 120,
                fontWeight: 700,
                "&:hover": { bgcolor: "#d45d4c" },
                px: { xs: 3, sm: 4 },
                ml: 1,
              }}
            >
              نقل الطاولة
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Dialog للتأكيد */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        fullScreen={isXs}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: isXs ? "100vw" : 420,
            maxWidth: "96vw",
            bgcolor: mode === "dark" ? "#232334" : "#fff",
            color: mode === "dark" ? "#fff" : "#232334",
            borderRadius: { xs: 0, sm: 3 },
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 700, color: "#EA7C69", textAlign: "center" }}
        >
          تأكيد نقل الطاولة
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              color: mode === "dark" ? "#fff" : "#232334",
              fontWeight: 500,
            }}
          >
            هل أنت متأكد من نقل الطلب من الطاولة
            <span
              style={{ color: "#EA7C69", fontWeight: 700, margin: "0 6px" }}
            >
              {currentTableObj?.name || form.table_id || "-"}
            </span>
            إلى الطاولة
            <span
              style={{ color: "#EA7C69", fontWeight: 700, margin: "0 6px" }}
            >
              {newTableObj?.name || selectedTable || "-"}
            </span>
            ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: { xs: 2, sm: 3 }, px: { xs: 2, sm: 3 } }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            color="secondary"
            variant="outlined"
            size={controlSize}
            sx={{ px: { xs: 2, sm: 3 } }}
          >
            إلغاء
          </Button>
          <Button
            onClick={handleConfirm}
            color="primary"
            variant="contained"
            size={controlSize}
            sx={{ bgcolor: "#EA7C69", px: { xs: 3, sm: 4 }, ml: 1 }}
          >
            نعم، نقل الطاولة
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!error}
        autoHideDuration={3000}
        onClose={() => setError("")}
      >
        <Alert severity="error">{error}</Alert>
      </Snackbar>
      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
      >
        <Alert severity="success">✅ تم نقل الطاولة بنجاح</Alert>
      </Snackbar>
    </>
  );
};

export default EditOrderFormTableNumber;
